/**
 * 訂位查詢頁的國別碼選單（2026-09-30）。
 *
 * 由來：查詢頁原本把國碼寫死 +886 —— 外國客人在序號模式下完全查不到自己的訂位，
 * 台灣客人也常把「+886 912…」整串打進手機欄（UAT v1.8.3.9 第 3 章）。
 * 改成跟訂位表單（components/form/PhoneField.vue）一樣：前面選國別、後面只填手機。
 *
 * 查詢頁本身是 blade + inline script，不是 Vue app；這支只負責把 TomSelect 掛上去，
 * 並把選到的撥號碼寫進隱藏欄位 #j-lookup-country-code，送出由頁面上的 script 讀取。
 * 這支沒載入時隱藏欄位維持預設 +886，頁面照原本行為運作。
 *
 * ⚠️ 國別清單一律引用 services/country-code.ts（8 個 repo 共用同一份內容），
 *    不可在這裡或 blade 裡另抄一份。
 * ⚠️ 輸出目錄 www/assets/js/order-lookup/ 是這支獨用的：webpack 建置會清空輸出目錄，
 *    與別的 bundle 共用目錄會互相刪掉對方（見 build/vue-tasks.mjs）。
 */
import countryCodeList, {} from '@vue/services/country-code';
import TomSelect from 'tom-select';
const select = document.querySelector('#j-lookup-country');
const dialInput = document.querySelector('#j-lookup-country-code');
if (select && dialInput) {
    const english = (select.dataset.locale ?? '').toLowerCase().startsWith('en');
    const nameOf = (item) => (english ? item.enUS : item.zhTW);
    // 選單的值是 ISO 代碼而不是撥號碼：撥號碼會重複（美/加 +1、哈/俄 +7），
    // TomSelect 的 valueField 重複時後出現的會被靜默丟棄（與 PhoneField 同一個理由）。
    const dialOf = (iso) => countryCodeList.find((item) => item.countryCode === iso)?.value ?? '+886';
    // 最近一次選定國別的時間（見下方 dropdown_open 的說明）；要在建立 TomSelect 前宣告
    let selectedAt = 0;
    const tomSelect = new TomSelect(select, {
        maxOptions: countryCodeList.length,
        valueField: 'countryCode',
        labelField: english ? 'enUS' : 'zhTW',
        searchField: ['zhTW', 'enUS', 'value', 'countryCode'],
        create: false,
        allowEmptyOption: false,
        // 選完就收起：否則清單會一直開著蓋住下面的「查詢訂位」按鈕（2026-09-30 實測）
        closeAfterSelect: true,
        options: countryCodeList,
        items: ['tw'],
        wrapperClass: 'lookup-country-select',
        render: {
            option: (data, escape) => `
        <div class="country-option d-flex gap-2 align-items-center">
          <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
          <span class="country-name flex-grow-1">${escape(nameOf(data))}</span>
          <span class="country-dial small text-muted">${escape(data.value)}</span>
        </div>
      `,
            // 收合時只顯示國旗與號碼，避免把右邊的手機欄擠掉
            item: (data, escape) => `
        <div class="d-flex gap-2 align-items-center">
          <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
          <span class="small">${escape(data.value)}</span>
        </div>
      `,
            no_results: () => `<div class="no-results">${english ? 'No matching country' : '查無此國家'}</div>`,
        },
        onChange: (iso) => {
            dialInput.value = dialOf(iso);
            selectedAt = Date.now();
            tomSelect.close();
            tomSelect.blur();
        },
    });
    // closeAfterSelect 單獨不夠（2026-09-30 實測）：先打字搜尋再點選項時，清單收起、失焦之後
    // 約 0.3 秒 TomSelect 又自己 focus 並展開，蓋住下面的「查詢訂位」按鈕。
    // 關掉 openOnFocus 能擋住，但代價是「點一下選單不會展開」，所以改成：
    // 剛選完的短時間內若又被自動打開，就收回去。之後客人自己再點仍照常展開。
    tomSelect.on('dropdown_open', () => {
        if (Date.now() - selectedAt < 800) {
            tomSelect.close();
            tomSelect.blur();
        }
    });
    dialInput.value = dialOf('tw');
}
